import React, { useState } from "react";
import CommonButton from "../../../components/CommonButton";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import GridComponent from "../../../components/GridComponent";
import { freecolumns, fullProductStructure} from "../../../utils/Customer/CustomerData";

const AdminFreeProductScreen: React.FC = () => {
    const [products, setProducts] = useState(fullProductStructure);
    const navigate = useNavigate();

    const handleEditClick = (row: Record<string, any>) => {
       navigate(`/admin/offer/claimProduct/createclaimProduct/${row.id}`)
    };

    const handleStatusToggle = (clickedRow: any) => {
        setProducts((prev) =>
            prev.map((item) =>
                item.sku === clickedRow.sku
                    ? {
                        ...item,
                        status: !item.status,
                    }
                    : item
            )
        );
    };

    return (
        <div className="p-3">

            <div className="mb-6 flex flex-col lg:flex-row lg:justify-between items-center">
                <div className="pb-6 lg:pb-0">
                    <h1 className="text-2xl font-bold text-logoHeading">
                        Free Product Management
                    </h1>

                    <p className="text-sm text-gray-500 mt-1">
                        Create, update and manage free product.
                    </p>
                </div>
                <CommonButton
                    text="Create Free Product"
                    variant="filled"
                    rounded="md"
                    iconTextClassName="px-2 py-2"
                    icon={<Plus size={18} />}
                    onClick={() => navigate("createclaimProduct")}
                />
            </div>
{/* 
            <GridComponent
                columns={freecolumns}
                data={products}
                pageSize={10}
                handleEditClick={handleEditClick}
                handleStatusToggle={handleStatusToggle}
            /> */}
        </div>
    );
}

export default AdminFreeProductScreen